"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = OverviewMechanics;
var jsx_runtime_1 = require("react/jsx-runtime");
var overviewStyles = __importStar(require("./OverviewMechanics.module.scss"));
var react_redux_1 = require("react-redux");
var groupMechanicsByType_1 = require("@utils/mechanics/groupMechanicsByType");
var OverviewMechanicsElement_1 = __importDefault(require("./OverviewMechanicsElement"));
var useCurrentLanguage_1 = require("@hooks/useCurrentLanguage");
var sidebarTranslator_1 = require("@components/Sidebar/localisation/sidebarTranslator");
var mechanicsFormTranslator_1 = require("@components/Forms/MechanicsForm/localisation/mechanicsFormTranslator");
function OverviewMechanics() {
    var mechanics = (0, react_redux_1.useSelector)(function (state) { return state.mechanicsSlice; }).mechanics;
    var types = (0, react_redux_1.useSelector)(function (state) { return state.mechanicsTypeSlice; }).types;
    var currentLang = (0, useCurrentLanguage_1.useCurrentLanguage)();
    if (mechanics.length <= 0) {
        console.log("no mechanics were found");
        return null;
    }
    var headerName = sidebarTranslator_1.sidebarTranslator[currentLang].mechanics;
    var t = mechanicsFormTranslator_1.mechanicsFormTranslator[currentLang];
    var groupedMechanics = (0, groupMechanicsByType_1.groupdMechanics)(types, mechanics);
    // Сгруппировать механики, у которых нет типа (например, typeId === "unknown" или не определен)
    var mechanicsWithoutType = (0, groupMechanicsByType_1.unsortedMechanics)(types, mechanics);
    // Добавляем механики без типа в отдельную группу
    if (mechanicsWithoutType.length > 0) {
        groupedMechanics.push({
            type: { id: "null", type: "unspecified" },
            mechanics: mechanicsWithoutType,
        });
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: overviewStyles.overview_container, id: "mechanics", children: [(0, jsx_runtime_1.jsx)("h2", { className: overviewStyles.overview_header, children: headerName }), (0, jsx_runtime_1.jsx)("ul", { style: { listStyle: "none", margin: "0", padding: "0" }, children: groupedMechanics.length > 0
                    ? groupedMechanics.map(function (gr) { return ((0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)(OverviewMechanicsElement_1.default, { group: gr, t: t }) }, gr.type.id)); })
                    : null })] }));
}
